// extracted by extract-css-chunks-webpack-plugin
module.exports = {"columns":"_1e-a35","collapse":"_3Lqgxu"};